import { useSelector } from 'react-redux';
import { selectQuestionnaireRoutes } from '../../../routes/slice';
import PreviewIncomeFromTheUS from './IncomeFromTheUS/preview';
import PreviewIncomeOutsideOfTheUS from './IncomeOutsideOfTheUS/preview';

export interface IPreviewWagesProps {}

export default function PreviewWages(props: IPreviewWagesProps) {
  const routes = useSelector(selectQuestionnaireRoutes).routes;

  return (
    <>
      <h1 className="w-full rounded-t-2xl bg-green text-white px-4  font-semibold pl-6 py-4 mt-8">
        Wages
      </h1>
      {/* {routes.income.wages && <PreviewGeneralWages />} */}
      {routes.income.wages.incomeFromTheUs && <PreviewIncomeFromTheUS />}
      {routes.income.wages.incomeOutsideOfTheUs && (
        <PreviewIncomeOutsideOfTheUS />
      )}
    </>
  );
}
